import React from "react";
import Flicking, { MoveEvent, WillChangeEvent } from "@egjs/react-flicking";
import "./flicking.css";
import { AutoPlay } from "@egjs/flicking-plugins";

const FlickingList = () => {
  const logos = [
    "KT",
    "LG",
    "NAVER",
    "KOREAN_AIR",
    "DUSAN",
    "AMORE",
    "HIVE",
    "HYUNDAI",
    "KAKAO",
    "NC",
    "SINSAEGAE",
  ];
  return (
    <Flicking
      viewportTag="div"
      cameraTag="div"
      cameraClass="camera"
      renderOnSameKey={false}
      plugins={[
        new AutoPlay({
          duration: 1000,
        }),
      ]}
      align="center"
      circular
    >
      {logos.map((logo, idx) => (
        <div key={idx}>
          <img src={`./images/logo/${logo}.png`} className="logo" alt="logo" />
        </div>
      ))}
    </Flicking>
  );
};

export default FlickingList;
